(() => {
  const loadCustomScripts = () => {
    window.custom_scripts.forEach((script) => {
      let s = document.createElement("script");
      s.setAttribute("src", script);
      document.head.insertAdjacentElement("beforeend", s);
    });
  };

  const hydrateDeferredMedia = () => {
    const deferredMedia = document.querySelectorAll(
      "img[data-src], img[data-srcset], source[data-src], source[data-srcset]",
    );
    if (!deferredMedia.length) {
      return;
    }

    const BATCH_SIZE = 10;
    let index = 0;

    const processBatch = () => {
      const end = Math.min(index + BATCH_SIZE, deferredMedia.length);
      for (let i = index; i < end; i++) {
        const element = deferredMedia[i];
        const dataSrcset = element.getAttribute("data-srcset");
        if (dataSrcset != null) {
          element.setAttribute("srcset", dataSrcset);
          element.removeAttribute("data-srcset");
        }
        const dataSrc = element.getAttribute("data-src");
        if (dataSrc != null) {
          element.setAttribute("src", dataSrc);
          element.removeAttribute("data-src");
        }
      }
      index = end;
      if (index < deferredMedia.length) {
        requestAnimationFrame(processBatch);
      }
    };

    processBatch();
  };

  const loadGTM = () => {
    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-PJZZJSL');
  }

  const loadScripts = () => {
    loadCustomScripts();
    requestAnimationFrame(hydrateDeferredMedia);
    loadGTM();
  };

  document.addEventListener("UserInteracted", loadScripts, false);
})();
